import React from "react";
import { FaLinkedin, FaEnvelope, FaFacebookF, FaInstagram, FaGithub } from "react-icons/fa";

const Footer = () => {
  const year = new Date();

  return (
    <footer
      className="w-full text-center p-6 bg-[#0c0a16] text-white"
    >
     {/* Social Icons */}
<div className="flex items-center justify-center mb-6 space-x-4">
  <a
    href="https://mail.google.com/mail/?view=cm&fs=1&to=maliksimra033@gmail.com"
    target="_blank"
    rel="noopener noreferrer"
    className="text-2xl text-white hover:text-violet-400 transition-all duration-300"
  >
    <FaEnvelope />
  </a>
  <a
    href="https://linkedin.com/in/simra-malik-ab452138b/"
    target="_blank"
    rel="noopener noreferrer"
    className="text-2xl text-white hover:text-violet-400 transition-all duration-300"
  >
    <FaLinkedin />
  </a>
  <a
    href="https://github.com/SIMRA-MALIK118"
    target="_blank"
    rel="noopener noreferrer"
    className="text-2xl text-white hover:text-violet-400 transition-all duration-300"
    aria-label="GitHub"
  >
    <FaGithub />
  </a>
  <a
    href="https://www.facebook.com/profile.php?id=61583767313656"
    target="_blank"
    rel="noopener noreferrer"
    className="text-2xl text-white hover:text-violet-400 transition-all duration-300"
    aria-label="Facebook"
  >
    <FaFacebookF />
  </a>
  <a
    href="https://www.instagram.com/simramalikdev/"
    target="_blank"
    rel="noopener noreferrer"
    className="text-2xl text-white hover:text-indigo-400 transition-all duration-300"
    aria-label="Instagram"
  >
    <FaInstagram />
  </a>
</div>


      {/* Divider Line */}
      <div className="w-full h-[1px] bg-gray-700 mb-4"></div>

      {/* Copyright Section */}
      <p className="text-sm text-gray-400 flex flex-wrap justify-center items-center gap-x-1">
        <span>© {year.getFullYear()} All Rights Reserved | Developed by</span>
        <span className="text-indigo-400 font-medium whitespace-nowrap">Simra Malik</span>
      </p>
    </footer>
  );
};

export default Footer;
